import { render } from "./PosterCaptionsMenuComponent.vue?vue&type=template&id=0fca4491&scoped=true"
import script from "./PosterCaptionsMenuComponent.vue?vue&type=script&lang=ts"
export * from "./PosterCaptionsMenuComponent.vue?vue&type=script&lang=ts"

import "./PosterCaptionsMenuComponent.vue?vue&type=style&index=0&id=0fca4491&lang=scss&scoped=true"
import "./PosterCaptionsMenuComponent.vue?vue&type=style&index=1&id=0fca4491&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0fca4491"

export default script